import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { GovernyInfo, ThiefActionType } from "../../../lib/types";
import HelpIcon from "../../Common/HelpIcon";
import { sendThieves } from "../../../store/actions";
import { DragescentState } from "../../../store/reducers/stateType";

interface IProps {
  sender: number;
  target: GovernyInfo;
  influence: number;
  gold: number;
  readyToThieves: boolean;
  crimeTypes: ThiefActionType[];
  limitReached: boolean;
}

const CrimeChoice = ({
  sender,
  target,
  influence,
  gold,
  readyToThieves,
  crimeTypes,
  limitReached
}: IProps) => {
  const dispatch = useDispatch();
  const id = useSelector((state: DragescentState) => state.governorate.id);

  return (
    <div className="dialog-content links">
      <ul>
        {
          crimeTypes.sort((
            a1: ThiefActionType,
            a2: ThiefActionType
          ) => (a1.id === 3 ? -1 : (a2.id === 3 ? 1 : 0)))
            .map((crimeType: ThiefActionType) => {
              const crimeDisabled = limitReached || !crimeType.canSendCrime || !readyToThieves
                || gold < Math.round(crimeType.gold * (1 - (0.05 * influence)))
                || crimeType.crimeTargets.includes(target.id);

              return (
                <li className="item ">
                  <a
                     style={{ paddingRight: "15px", display: "inline-block" }}
                     className={`link ${crimeDisabled ? "disabled" : ""}`}
                     onClick={() => crimeDisabled
                       || dispatch(
                         sendThieves(
                           crimeType.id,
                           target.id,
                           influence,
                           sender,
                           sender.toString(10) === id.toString(10)
                         )
                       )}
                  >
                    {crimeType.name}
                    <span>
                  {Math.round(crimeType.gold * (1 - (0.05 * influence)))}
                </span>
                    <i className="icon icon-sm icon-zlato gold"/>
                  </a>
                  <HelpIcon
                    title={crimeType.name}
                    content={crimeType.description}
                    iconClasses={["white"]}
                  />
                </li>
              )
            })
        }
      </ul>
    </div>
  )
}

export default CrimeChoice;
